import { gql } from "@apollo/client";

export const GetSuppliers = gql`
  query GetSuppliers(
    $token: String!
    $after: Cursor
    $first: Int
    $customer_id: ID!
    $orderBy: AtsAcLdgrOrder
    $input: LdgrQueryData!
    $name: String
  ) {
    GetSuppliers(
      token: $token
      after: $after
      customer_id: $customer_id
      first: $first
      orderBy: $orderBy
      input: $input
      where: { or: [{ descContainsFold: $name }] }
    ) {
      edges {
        node {
          id
          desc
          multiLocation
          itemsCount
          empCount
          supplier_details {
            address
            city
            pin
            state
            country
            email
            phone
            gstNo
            tanNo
            vatNo
            panNo
            bankAcNo
            bankName
            bankBranch
            bankIfsc
            bankMicr
            contactPerson
            contactPersonAddress
            contactPersonCity
            contactPersonPin
            contactPersonState
            contactPersonCountry
            contactPersonEmail
            contactPersonMobile
            contactPersonAadhar
            alterContactPerson
            alterContactPersonEmail
            alterContactPersonMobile
            alterContactPersonAadhar
            proficiency
            avgRating
            lastSupplyRefNo
            lastSupplyRating
            lastSupplyRemarks
            lastSupplyDate
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export const GetSupplierMultiLocation = gql`
  query GetSupplierMultiLocation(
    $token: String!
    $after: Cursor
    $first: Int
    $customer_id: ID!
    $supplier_id: ID!
    $orderBy: AtsAcLdgrMultiLocationOrder
    $name: String
  ) {
    GetSupplierMultiLocation(
      token: $token
      after: $after
      customer_id: $customer_id
      supplier_id: $supplier_id
      first: $first
      orderBy: $orderBy
      where: { or: [{ addressContainsFold: $name }] }
    ) {
      edges {
        node {
          id
          address
          city
          pin
          state
          country
          email
          phone
          gstNo
          tanNo
          vatNo
          panNo
          contactPerson
          contactPersonAddress
          contactPersonCity
          contactPersonPin
          contactPersonState
          contactPersonCountry
          contactPersonEmail
          contactPersonMobile
          contactPersonAadhar
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;
//By Ids

export const GetSupplierByNodeId = gql`
  query GetSupplierByNodeId($id: ID!, $token: String!) {
    node(id: $id, token: $token) {
      id
      ... on AtsAcLdgr {
        desc
        multiLocation
        includeDeviceType
        supplier_details {
          id
          address
          city
          pin
          state
          country
          email
          phone
          gstNo
          tanNo
          vatNo
          panNo
          bankAcNo
          bankName
          bankBranch
          bankIfsc
          bankMicr
          contactPerson
          contactPersonAddress
          contactPersonCity
          contactPersonPin
          contactPersonState
          contactPersonCountry
          contactPersonEmail
          contactPersonMobile
          contactPersonAadhar
          alterContactPerson
          alterContactPersonEmail
          alterContactPersonMobile
          alterContactPersonAadhar
          proficiency
          avgRating
          lastSupplyRefNo
          lastSupplyRating
          lastSupplyRemarks
          lastSupplyDate
        }
      }
    }
  }
`;

export const GetLocationByNodeId = gql`
  query GetLocationByNodeId($id: ID!, $token: String!) {
    node(id: $id, token: $token) {
      id
      ... on AtsAcLdgrMultiLocation {
        address
        city
        pin
        state
        country
        email
        phone
        gstNo
        tanNo
        vatNo
        panNo
        contactPerson
        contactPersonAddress
        contactPersonCity
        contactPersonPin
        contactPersonState
        contactPersonCountry
        contactPersonEmail
        contactPersonMobile
        contactPersonAadhar
      }
    }
  }
`;

export const GetRfqTrnSupplyNode = gql`
  query GetRfqTrnSupplyNode($id: ID!, $key: String!) {
    GetRfqTrnSupplyNode(id: $id, key: $key) {
      id
      isAccepted
      quotedAnyChanges
      itemDescChanged
      quotedDesc
      quotedQty
      quotedRate
      quotedRemarks
      quotedDelvChrg
      quotedInstChrg
      quotedTax
      quotedOther
      item {
        desc
        code
      }
      rfqTrn {
        udfItemDesc
        itemPaymentTerms
        mrf_trn_details {
          reqQty
        }
      }
    }
  }
`;

export const GetSuppliersForPOOptions = gql`
  query GetSuppliersForPOOptions(
    $token: String!
    $after: Cursor
    $first: Int
    $customer_id: ID!
    $orderBy: AtsAcLdgrOrder
    $finYrId: ID!
    $name: String
  ) {
    GetSuppliersForPO(
      token: $token
      after: $after
      customer_id: $customer_id
      finYrId: $finYrId
      first: $first
      orderBy: $orderBy
      where: { or: [{ descContainsFold: $name }] }
    ) {
      edges {
        node {
          id
          desc
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export const GetSuppliersForPO = gql`
  query GetSuppliersForPO(
    $token: String!
    $after: Cursor
    $first: Int
    $customer_id: ID!
    $orderBy: AtsAcLdgrOrder
    $finYrId: ID!
    $name: String
  ) {
    GetSuppliersForPO(
      token: $token
      after: $after
      customer_id: $customer_id
      finYrId: $finYrId
      first: $first
      orderBy: $orderBy
      where: { or: [{ descContainsFold: $name }] }
    ) {
      edges {
        node {
          id
          desc
          multiLocation
          supplier_details {
            address
            city
            pin
            state
            country
            email
            phone
            gstNo
            tanNo
            vatNo
            panNo
            bankAcNo
            bankName
            bankBranch
            bankIfsc
            bankMicr
            contactPerson
            contactPersonAddress
            contactPersonCity
            contactPersonPin
            contactPersonState
            contactPersonCountry
            contactPersonEmail
            contactPersonMobile
            contactPersonAadhar
            alterContactPerson
            alterContactPersonEmail
            alterContactPersonMobile
            alterContactPersonAadhar
            proficiency
            avgRating
            lastSupplyRefNo
            lastSupplyRating
            lastSupplyRemarks
            lastSupplyDate
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;
